import type { TimelinePoint } from "@/mocks/fancha";

export default function TimelineBlock({ points }: { points: TimelinePoint[] }) {
  return (
    <ol className="relative ml-2 space-y-8 border-l-2 border-background-200 pl-8">
      {points.map((p) => (
        <li key={p.time + p.title} className="relative">
          <span className="absolute -left-[41px] top-1 flex h-5 w-5 items-center justify-center">
            <span className="h-2.5 w-2.5 rounded-full bg-accent-500 ring-4 ring-background-50" />
          </span>
          <p className="inline-flex items-center rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
            {p.time}
          </p>
          <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
          <p className="mt-1.5 text-sm leading-7 text-foreground-600">{p.text}</p>
        </li>
      ))}
    </ol>
  );
}